import {Pipe, PipeTransform} from "@angular/core";
import {Language} from "../../shared/api/languages/api.models";

@Pipe({ name : 'languageIdFilter'})
export class LanguageIdFilterPipe implements PipeTransform {
    transform(values: any[], languages: Language[], needle: string): any {
        if (!needle) {
            return values;
        }

        let allowedLanguageIds = [];
        let returnValues       = [];

        languages.forEach((language: Language) => {
            if (language.label.toLowerCase().indexOf(needle.toLowerCase()) === -1) {
                return;
            }

            allowedLanguageIds.push(language.id);
        });

        values.forEach((value: any) => {
            let languageId = 0;

            if (typeof value === 'object') {
                languageId = value.value;
            } else if (typeof value === "number") {
                languageId = value;
            }

            if (allowedLanguageIds.indexOf(languageId) > -1) {
                returnValues.push(value);
            }
        });

        return returnValues;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/settings/users/languageIdFilter.pipe.ts